<template>
  <a-typography-paragraph v-bind="attrs" :class="bem.b()" :ellipsis="ellipsis">
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-typography-paragraph>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { computed, useAttrs } from 'vue'

import { textParagraphProps } from './text'

// 1.defineOptions
defineOptions({ name: 'LlTextParagraph' })

// 2.props
const props = defineProps(textParagraphProps)
const attrs = useAttrs()

// 3.computes/const
const bem = createNamespace('text-paragraph')

const ellipsis = computed(() => {
  // 自定义传入对象配置
  if (attrs.ellipsis) {
    return attrs.ellipsis
  } else {
    return props.isEllipsis
      ? {
          rows: props.rows,
          tooltip: props.showTooltip,
          expandable: props.expandable,
          symbol: props.symbol || 'more',
        }
      : false
  }
})
</script>
